// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"48cf9b87","492":"c2ddf16d"}[chunkId] + ".chunk.js";
};